import axiosInstance from "axiosInstance";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import LoaderScreen from "../Common/LoaderScreen";
import MyFarmsEmpty from "./MyFarmsEmpty";

const statusOptions = [
  {
    id: "All",
    name: "All",
  },
  {
    id: "Pending",
    name: "Pending",
  },
  {
    id: "Paid",
    name: "Paid",
  },
  {
    id: "Project Execution",
    name: "Project Execution",
  },
  {
    id: "Project Completion",
    name: "Project Completion",
  },
  {
    id: "Payment Disbursed",
    name: "Payment Disbursed",
  }
  
];


function MyProjects() {
  const router = useRouter();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredProjects, setFilteredProjects] = useState([]);
 const [activeFilter, setActiveFilter] = useState("All");

  const fetchData = async (status) => {
   try {
     const response = await axiosInstance.get(`/api/booking/my-bookings`, {
       params: { status },
     });
     setProjects(response.data);
     setLoading(false);
   } catch (error) {
     console.error(error);
     setLoading(false);
   }
 };

 useEffect(() => {
   fetchData(activeFilter);
 }, [activeFilter]);

 const goBack = () => {
   router.back();
 };

 const handleFilterClick = (filter) => {
   setActiveFilter(filter);
 };

  const showEmptyComponent = loading || (projects.length === 0);

  return (
    <>
      <section className="topBar">
        <div className="left-wrrow" onClick={goBack}>
          <span className="iconWrapper">
            <svg
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.46849 0.414376C5.79194 0.673133 5.84438 1.1451 5.58562 1.46855L1.96044 6.00003L5.58562 10.5315C5.84438 10.855 5.79194 11.3269 5.46849 11.5857C5.14505 11.8444 4.67308 11.792 4.41432 11.4685L0.414321 6.46855C0.195189 6.19464 0.195189 5.80542 0.414321 5.53151L4.41432 0.531506C4.67308 0.20806 5.14505 0.155619 5.46849 0.414376Z"
                fill="#333333"
              />
            </svg>
          </span>
        </div>
        <div className="middleContent">
          <h3>My Farms</h3>
        </div>
        <div className="middleContent"> </div>
      </section>
      <section className="headerGap"></section>
      <section className="menuProject">
        <ul className="scrollMenu">
          {statusOptions.map((option) => (
            <li key={option.id} className="scrollMenu-list">
              <a
                href="#"
                className={`scrollMenu-link ${activeFilter === option.id ? "active" : ""}`}
                onClick={() => handleFilterClick(option.id)}
              >
                {option.name}
              </a>
            </li>
          ))}
        </ul>
      </section>
      {loading ? (
        <LoaderScreen />
      ) : showEmptyComponent ? (
        <MyFarmsEmpty />
      ) : (
        <>
          {/* Render the filtered projects */}
          <section className="allProjects">
            {projects.map((project) => (
              <Link href={`/myfarms/${project._id}`} key={project._id} className="singleProject">
                <div className="singleProject-left">
                  <figure className="singleProject-thumb">
                    <img src={project.projectId?.thumbnailImage} alt="project image " />
                  </figure>
                </div>
                <div className="singleProject-right">
                  <h3 className="projectName">{project.projectId?.projectName}</h3>
                  <p className="price">
                    {project.projectId?.perShareCost.toLocaleString()} <span>/Unit</span>
                  </p>
                  <div className="roi">
                    <span className="icon">
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.12257 1.19674C8.3219 0.967322 8.6781 0.967322 8.87743 1.19674L9.93918 2.41873C10.2786 2.80937 10.7954 2.99747 11.3065 2.91639L12.9053 2.66277C13.2055 2.61515 13.4783 2.84412 13.4836 3.14799L13.5114 4.76656C13.5203 5.28398 13.7953 5.76026 14.239 6.02668L15.6268 6.8601C15.8873 7.01657 15.9492 7.36736 15.7578 7.6035L14.7388 8.86131C14.413 9.2634 14.3175 9.80501 14.4861 10.2943L15.0135 11.8248C15.1125 12.1121 14.9344 12.4206 14.6361 12.4785L13.0469 12.787C12.5389 12.8856 12.1176 13.2391 11.9323 13.7223L11.3525 15.2337C11.2437 15.5175 10.909 15.6393 10.6432 15.4919L9.22753 14.7068C8.77498 14.4558 8.22502 14.4558 7.77247 14.7068L6.35681 15.4919C6.09103 15.6393 5.75631 15.5175 5.64746 15.2337L5.0677 13.7223C4.88236 13.2391 4.46106 12.8856 3.95306 12.787L2.36391 12.4785C2.06556 12.4206 1.88746 12.1121 1.98647 11.8248L2.51388 10.2943C2.68247 9.80501 2.58697 9.2634 2.26121 8.86131L1.24215 7.6035C1.05083 7.36736 1.11269 7.01657 1.37323 6.8601L2.76103 6.02668C3.20467 5.76026 3.47965 5.28398 3.48856 4.76656L3.51642 3.14799C3.52165 2.84412 3.79452 2.61515 4.09468 2.66277L5.69351 2.91639C6.20461 2.99747 6.72141 2.80937 7.06082 2.41873L8.12257 1.19674Z"
                          stroke="#FF5660"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.5599 5.43994L5.43994 11.5599"
                          stroke="#FF5660"
                          stroke-width="0.75"
                          stroke-linecap="round"
                        />
                        <circle
                          cx="6.80012"
                          cy="6.79987"
                          r="1.055"
                          stroke="#FF5660"
                          stroke-width="0.75"
                        />
                        <circle
                          cx="10.2"
                          cy="10.2"
                          r="1.055"
                          stroke="#FF5660"
                          stroke-width="0.75"
                        />
                      </svg>
                    </span>
                    <span className="text">
                      {project.projectId?.projectType === "Shariah" ? (
                        <>
                          {project.projectId?.rateOfInterestMin}% -
                          {project.projectId?.rateOfInterestMax}%
                        </>
                      ) : (
                        <>{project.projectId?.rateOfInterestMin}%</>
                      )}
                    </span>
                  </div>
                  <div className="date">
                    <span className="icon">
                      <svg
                        width="12"
                        height="15"
                        viewBox="0 0 12 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.33333 14.0503C0.966667 14.0503 0.652667 13.9198 0.391333 13.6589C0.130444 13.3976 0 13.0836 0 12.7169V3.38359C0 3.01692 0.130444 2.70314 0.391333 2.44225C0.652667 2.18092 0.966667 2.05025 1.33333 2.05025H2V0.716919H3.33333V2.05025H8.66667V0.716919H10V2.05025H10.6667C11.0333 2.05025 11.3473 2.18092 11.6087 2.44225C11.8696 2.70314 12 3.01692 12 3.38359V12.7169C12 13.0836 11.8696 13.3976 11.6087 13.6589C11.3473 13.9198 11.0333 14.0503 10.6667 14.0503H1.33333ZM1.33333 12.7169H10.6667V6.05025H1.33333V12.7169ZM1.33333 4.71692H10.6667V3.38359H1.33333V4.71692ZM6 8.71692C5.81111 8.71692 5.65289 8.65292 5.52533 8.52492C5.39733 8.39736 5.33333 8.23914 5.33333 8.05025C5.33333 7.86136 5.39733 7.70292 5.52533 7.57492C5.65289 7.44736 5.81111 7.38358 6 7.38358C6.18889 7.38358 6.34733 7.44736 6.47533 7.57492C6.60289 7.70292 6.66667 7.86136 6.66667 8.05025C6.66667 8.23914 6.60289 8.39736 6.47533 8.52492C6.34733 8.65292 6.18889 8.71692 6 8.71692ZM3.33333 8.71692C3.14444 8.71692 2.986 8.65292 2.858 8.52492C2.73044 8.39736 2.66667 8.23914 2.66667 8.05025C2.66667 7.86136 2.73044 7.70292 2.858 7.57492C2.986 7.44736 3.14444 7.38358 3.33333 7.38358C3.52222 7.38358 3.68067 7.44736 3.80867 7.57492C3.93622 7.70292 4 7.86136 4 8.05025C4 8.23914 3.93622 8.39736 3.80867 8.52492C3.68067 8.65292 3.52222 8.71692 3.33333 8.71692ZM8.66667 8.71692C8.47778 8.71692 8.31956 8.65292 8.192 8.52492C8.064 8.39736 8 8.23914 8 8.05025C8 7.86136 8.064 7.70292 8.192 7.57492C8.31956 7.44736 8.47778 7.38358 8.66667 7.38358C8.85556 7.38358 9.01378 7.44736 9.14133 7.57492C9.26933 7.70292 9.33333 7.86136 9.33333 8.05025C9.33333 8.23914 9.26933 8.39736 9.14133 8.52492C9.01378 8.65292 8.85556 8.71692 8.66667 8.71692ZM6 11.3836C5.81111 11.3836 5.65289 11.3196 5.52533 11.1916C5.39733 11.064 5.33333 10.9058 5.33333 10.7169C5.33333 10.528 5.39733 10.3698 5.52533 10.2423C5.65289 10.1143 5.81111 10.0503 6 10.0503C6.18889 10.0503 6.34733 10.1143 6.47533 10.2423C6.60289 10.3698 6.66667 10.528 6.66667 10.7169C6.66667 10.9058 6.60289 11.064 6.47533 11.1916C6.34733 11.3196 6.18889 11.3836 6 11.3836ZM3.33333 11.3836C3.14444 11.3836 2.986 11.3196 2.858 11.1916C2.73044 11.064 2.66667 10.9058 2.66667 10.7169C2.66667 10.528 2.73044 10.3698 2.858 10.2423C2.986 10.1143 3.14444 10.0503 3.33333 10.0503C3.52222 10.0503 3.68067 10.1143 3.80867 10.2423C3.93622 10.3698 4 10.528 4 10.7169C4 10.9058 3.93622 11.064 3.80867 11.1916C3.68067 11.3196 3.52222 11.3836 3.33333 11.3836ZM8.66667 11.3836C8.47778 11.3836 8.31956 11.3196 8.192 11.1916C8.064 11.064 8 10.9058 8 10.7169C8 10.528 8.064 10.3698 8.192 10.2423C8.31956 10.1143 8.47778 10.0503 8.66667 10.0503C8.85556 10.0503 9.01378 10.1143 9.14133 10.2423C9.26933 10.3698 9.33333 10.528 9.33333 10.7169C9.33333 10.9058 9.26933 11.064 9.14133 11.1916C9.01378 11.3196 8.85556 11.3836 8.66667 11.3836Z"
                          fill="#FF5660"
                        />
                      </svg>
                    </span>
                    <span className="text">
                      {project.projectId?.totalDuration.split(" ").slice(0, 2).join(" ")}{" "}
                    </span>
                  </div>
                  <Link href={`/myfarms/${project._id}`} className="btnVisit">
                    Visit
                  </Link>
                </div>
              </Link>
            ))}
          </section>
        </>
      )}

      <section className="headerGap"></section>
    </>
  );
}

export default MyProjects;
